// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ag40","importantInfo":"styles_importantInfo__2t3eF"};